var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._g(_vm._b({},'v-icon',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.svgPath)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }